<template>

  <div>

    <Popup :showThis="isOpen" :title="popupText" :definition="popupDefinition"  @click="isOpen=false"/>

    <div class="grid-container" style="">

    <div class="header camber-header">

      <div class="introText">
        <div @click="isOpen=true; popupText='CAMBER ANGLE'; popupDefinition=camberContent.camberDefinition">
        <p><span class="redText">Camber angle</span> is inward or outward wheel tilt. When it is out of manufacturer specifications, your vehicle will experience increased tire wear, decreased stopping distance and poor handling.<span class="icon-information"></span></p>
        </div>
        <div class="treadWear">
          <h6>Tread Wear and Fuel Efficiency</h6>
          <p>Tires are scrubbing along the road, reducing your fuel efficiency and tire tread life.</p>
        </div>
      </div>


      <div class="popupHandler" @click="show =!show">
      <Transition name="slide-fade">
        <div class="lesschwab-popup" v-if="show">
          <p>{{ camberContent.introPopup }}</p>
          <div class="icon-close"></div>
        </div>
      </Transition>
      </div>

    </div>
    </div>

    <div class="interactive">

      <div class="passengerCamber">

        <div class="blackUnderline">
          <div class="toeTreadWear">
            <img :style="passengerSliderValue > 60 ? null : 'transform: scaleX(-1);'"
            :src="
            passengerSliderValue <= 10 ? camberContent.camber4 :
            passengerSliderValue <= 24 ? camberContent.camber3 :
            passengerSliderValue <= 39 ? camberContent.camber2 :
            passengerSliderValue >= 40 && passengerSliderValue <= 60 ? camberContent.tireImage :
            passengerSliderValue >= 61 && passengerSliderValue <= 75 ? camberContent.camber2 :
            passengerSliderValue >= 76 && passengerSliderValue <= 86 ? camberContent.camber3 :
            passengerSliderValue >= 87 && passengerSliderValue <= 100 ? camberContent.camber4 : null"
            >
          </div>
        </div>

        <div class="lesschwabSliderContainer camber">
          <input type="range" @change="hidePopup" v-model.number="passengerSliderValue" class="slider">
        </div>

        <div class="lesschwabSliderButton">
          <img class="sliderButtons camber" :src=" passengerSliderValue >= 25 && passengerSliderValue <= 75 ? camberContent.passImage : camberContent.failImage ">
          <button @click="decreasePassenger()" class="increaseScale plus background-left left"></button>
          <button @click="increasePassenger()" class="increaseScale minus background-right right"></button>
        </div>


        <h6>{{ camberContent.passengerSlider }}</h6>
      </div>

      <div class="carDiagram">

        <div class="diagram">
          <div class="car" @click="showLines=!showLines;">
            <img src="../assets/camberCarOutlines.svg">
          </div>

          <!--Left Tire Mask-->
          <div :class="
            passengerSliderValue <= 10 ? 'tireMask camber leftTire most-flipped camber-wear-3' :
            passengerSliderValue <= 24 ? 'tireMask camber leftTire more-flipped camber-wear-2':
            passengerSliderValue <= 39 ? 'tireMask camber leftTire less-flipped camber-wear-1' :
            passengerSliderValue >= 40 && passengerSliderValue <= 60 ? null :
            passengerSliderValue >= 61 && passengerSliderValue <= 75 ? 'tireMask camber leftTire less-flipped camber-wear-1' :
            passengerSliderValue >= 76 && passengerSliderValue <= 86 ? 'tireMask camber leftTire more-flipped camber-wear-2' :
            passengerSliderValue >= 87 && passengerSliderValue <= 100 ? 'tireMask camber leftTire most-flipped camber-wear-3' :
          null"

          :style="
            passengerSliderValue <= 10 ? 'transform: rotate(-5deg) scaleX(-1)' :
            passengerSliderValue <= 24 ? 'transform: rotate(-3deg) scaleX(-1)':
            passengerSliderValue <= 39 ? 'transform: rotate(-2deg) scaleX(-1)' :
            passengerSliderValue >= 40 && passengerSliderValue <= 60 ? null :
            passengerSliderValue >= 61 && passengerSliderValue <= 75 ? 'transform: rotate(2deg)' :
            passengerSliderValue >= 76 && passengerSliderValue <= 86 ? 'transform: rotate(3deg)' :
            passengerSliderValue >= 87 && passengerSliderValue <= 100 ? 'transform: rotate(5deg)' :
          null" >
          </div>

          <!--Left Tire Image-->
          <div class="tire leftTire">
            <img
            :src="
            passengerSliderValue <= 10 ? camberContent.camber4 :
            passengerSliderValue <= 24 ? camberContent.camber3 :
            passengerSliderValue <= 39 ? camberContent.camber2 :
            passengerSliderValue >= 40 && passengerSliderValue <= 60 ? camberContent.tireImage :
            passengerSliderValue >= 61 && passengerSliderValue <= 75 ? camberContent.camber2 :
            passengerSliderValue >= 76 && passengerSliderValue <= 86 ? camberContent.camber3 :
            passengerSliderValue >= 87 && passengerSliderValue <= 100 ? camberContent.camber4 :
            null"

            :style="
            passengerSliderValue <= 10 ? 'transform: rotate(-5deg) scaleX(-1)' :
            passengerSliderValue <= 24 ? 'transform: rotate(-3deg) scaleX(-1)':
            passengerSliderValue <= 39 ? 'transform: rotate(-2deg) scaleX(-1)' :
            passengerSliderValue >= 40 && passengerSliderValue <= 60 ? null :
            passengerSliderValue >= 61 && passengerSliderValue <= 75 ? 'transform: rotate(2deg)' :
            passengerSliderValue >= 76 && passengerSliderValue <= 86 ? 'transform: rotate(3deg)' :
            passengerSliderValue >= 87 && passengerSliderValue <= 100 ? 'transform: rotate(5deg)' :
            null"
            >
          </div>


          <!--Right Tire Mask-->
          <div :class="
            driverSliderValue <= 10 ? 'tireMask camber rightTire most-flipped camber-wear-3' :
            driverSliderValue <= 24 ? 'tireMask camber rightTire more-flipped camber-wear-2':
            driverSliderValue <= 39 ? 'tireMask camber rightTire less-flipped camber-wear-1' :
            driverSliderValue >= 40 && driverSliderValue <= 60 ? null :
            driverSliderValue >= 61 && driverSliderValue <= 75 ? 'tireMask camber rightTire less-flipped camber-wear-1' :
            driverSliderValue >= 76 && driverSliderValue <= 86 ? 'tireMask camber rightTire more-flipped camber-wear-2' :
            driverSliderValue >= 87 && driverSliderValue <= 100 ? 'tireMask camber rightTire most-flipped camber-wear-3' :
          null"

          :style="
            driverSliderValue <= 10 ? 'transform: rotate(-5deg) scaleX(-1)' :
            driverSliderValue <= 24 ? 'transform: rotate(-3deg) scaleX(-1)':
            driverSliderValue <= 39 ? 'transform: rotate(-2deg) scaleX(-1)' :
            driverSliderValue >= 40 && driverSliderValue <= 60 ? null :
            driverSliderValue >= 61 && driverSliderValue <= 75 ? 'transform: rotate(2deg)' :
            driverSliderValue >= 76 && driverSliderValue <= 86 ? 'transform: rotate(3deg)' :
            driverSliderValue >= 87 && driverSliderValue <= 100 ? 'transform: rotate(5deg)' :
          null" >
          </div>

          <!--Right Tire Image-->
          <div class="tire rightTire">
            <img
            :src="
            driverSliderValue <= 10 ? camberContent.camber4 :
            driverSliderValue <= 24 ? camberContent.camber3 :
            driverSliderValue <= 39 ? camberContent.camber2 :
            driverSliderValue >= 40 && driverSliderValue <= 60 ? camberContent.tireImage :
            driverSliderValue >= 61 && driverSliderValue <= 75 ? camberContent.camber2 :
            driverSliderValue >= 76 && driverSliderValue <= 86 ? camberContent.camber3 :
            driverSliderValue >= 87 && driverSliderValue <= 100 ? camberContent.camber4 :
            null"

            :style="
            driverSliderValue <= 10 ? 'transform: rotate(-5deg) scaleX(-1)' :
            driverSliderValue <= 24 ? 'transform: rotate(-3deg) scaleX(-1)':
            driverSliderValue <= 39 ? 'transform: rotate(-2deg) scaleX(-1)' :
            driverSliderValue >= 40 && driverSliderValue <= 60 ? null :
            driverSliderValue >= 61 && driverSliderValue <= 75 ? 'transform: rotate(2deg)' :
            driverSliderValue >= 76 && driverSliderValue <= 86 ? 'transform: rotate(3deg)' :
            driverSliderValue >= 87 && driverSliderValue <= 100 ? 'transform: rotate(5deg)' :
            null"
            >
          </div>

          <div class="axel">
            <img src="../assets/camberFrontEndComponents.svg">
          </div>

          <ComponentRoadLines
            :tilt="
            passengerSliderValue <= 10 && driverSliderValue <= 10 ? 'roadlines to-left-extreme' :
            passengerSliderValue <= 10 && driverSliderValue <= 24 ? 'roadlines to-left-3' :
            passengerSliderValue <= 10 && driverSliderValue <= 39 ? 'roadlines to-left-2' :


            passengerSliderValue <= 24 && driverSliderValue <= 10 ? 'roadlines to-left-3' :
            passengerSliderValue <= 24 && driverSliderValue <= 24 ? 'roadlines to-left-2' :
            passengerSliderValue <= 24 && driverSliderValue <= 39 ? 'roadlines to-left-3' :

            passengerSliderValue <= 39 && driverSliderValue <= 10 ? 'roadlines to-left-1' :
            passengerSliderValue <= 39 && driverSliderValue <= 24 ? 'roadlines to-left-2' :
            passengerSliderValue <= 39 && driverSliderValue <= 39 ? 'roadlines to-left-3' :

            //opposite way

            passengerSliderValue >= 61 && driverSliderValue <= 75 ? 'roadlines to-right-1' :
            passengerSliderValue >= 61 && driverSliderValue <= 86 ? 'roadlines to-right-2' :
            passengerSliderValue >= 61 && driverSliderValue <= 100 ? 'roadlines to-right-3' :

            passengerSliderValue >= 76 && driverSliderValue <= 75 ? 'roadlines to-right-2' :
            passengerSliderValue >= 76 && driverSliderValue <= 86 ? 'roadlines to-right-2' :
            passengerSliderValue >= 76 && driverSliderValue <= 100 ? 'roadlines to-right-3' :

            passengerSliderValue >= 87 && driverSliderValue >= 87 ? 'roadlines to-right-extreme' :
            null" v-if="showLines"/>

        </div>

        <div class="disclaimer">
          <p>{{ camberContent.disclaimer }}</p>
          <button @click="resetAll()" style="max-width: 200px;" class="button is-appointment-enabled" title="reset button">Reset</button>
          <div class="laneToggle" @click="showLines = !showLines" >
            <toggle :currValue="showLines"></toggle>
            <p>{{ showLines ? 'Show' : 'Hide' }} lane drift</p>
          </div>
        </div>


      </div>

      <div class="driverCamber">

        <div class="blackUnderline">
          <div class="toeTreadWear">
            <img :style="driverSliderValue > 60 ? null : 'transform: scaleX(-1);'"
            :src="
            driverSliderValue <= 10 ? camberContent.camber4 :
            driverSliderValue <= 24 ? camberContent.camber3 :
            driverSliderValue <= 39 ? camberContent.camber2 :
            driverSliderValue >= 40 && driverSliderValue <= 60 ? camberContent.tireImage :
            driverSliderValue >= 61 && driverSliderValue <= 75 ? camberContent.camber2 :
            driverSliderValue >= 76 && driverSliderValue <= 86 ? camberContent.camber3 :
            driverSliderValue >= 87 && driverSliderValue <= 100 ? camberContent.camber4 : null"
            >
          </div>
        </div>

        <div class="lesschwabSliderContainer camber">
          <input type="range" @change="hidePopup" v-model.number="driverSliderValue" class="slider">
        </div>

        <div class="lesschwabSliderButton">
          <img class="sliderButtons camber" style="transform: scaleX(-1)" :src=" driverSliderValue >= 25 && driverSliderValue <= 75 ? camberContent.passImage : camberContent.failImage ">
          <div @click="decreaseDriver()" class="increaseScale minus background-left left"></div>
          <div @click="increaseDriver()" class="increaseScale plus background-right right"></div>
        </div>

        <h6>{{ camberContent.driverSlider }}</h6>

      </div>
    </div>

  </div>

</template>

<script>
import ComponentRoadLines from "./ComponentRoadLines.vue";
import toggle from "./ComponentToggle.vue";
import Popup from "./Popup.vue";
import {ref} from "vue";

export default {
  name: 'PageCamber',
  props: ['camberContent'],
  components: {
    Popup,
    ComponentRoadLines,
    toggle
  },
  setup() {
    const isOpen = ref(false);
    return {isOpen};
  },
  data() {
    return {
      passengerSliderValue: 50,
      driverSliderValue: 50,
      currentPassengerStep: 4,
      maxPassengerSteps: 7,
      currentDriverStep: 4,
      maxDriverSteps: 7,
      jumpSize: 10,
      show: true,
      showModal: false,
      showLines: false,
      popupText: "title",
      popupDefinition: "definition",
    };
  },
  watch: {
    passengerSliderValue: function(value) {
      if(value <= 10) {this.currentPassengerStep = 1}
      if(value <= 24 && value >= 11) {this.currentPassengerStep = 2}
      if(value <= 39 && value >= 23) {this.currentPassengerStep = 3}
      if(value >= 40 && value <= 60) {this.currentPassengerStep = 4}
      if(value >= 61 && value <= 75) {this.currentPassengerStep = 5}
      if(value >= 76 && value <= 86) {this.currentPassengerStep = 6}
      if(value >= 87 && value <= 100) {this.currentPassengerStep = 7}
    },
    driverSliderValue: function(value) {
      if(value <= 10) {this.currentDriverStep = 1}
      if(value <= 24 && value >= 11) {this.currentDriverStep = 2}
      if(value <= 39 && value >= 23) {this.currentDriverStep = 3}
      if(value >= 40 && value <= 60) {this.currentDriverStep = 4}
      if(value >= 61 && value <= 75) {this.currentDriverStep = 5}
      if(value >= 76 && value <= 86) {this.currentDriverStep = 6}
      if(value >= 87 && value <= 100) {this.currentDriverStep = 7}
    }
  },
  methods : {
    hidePopup() {
      this.show = false;
    },
    resetAll() {
      this.passengerSliderValue = 50;
      this.driverSliderValue = 50;
      this.show = true;
      this.showLines = false;
    },
    increasePassenger() {
      if(this.currentPassengerStep === this.maxPassengerSteps) { return; } else {
        this.currentPassengerStep += 1;
        this.checkPassengerLocation();
      }
    },
    decreasePassenger() {
      if(this.currentPassengerStep === 1) { return; } else {
        this.currentPassengerStep -= 1;
        this.checkPassengerLocation();
      }
    },
    checkPassengerLocation() {
      if(this.currentPassengerStep === 1) {this.passengerSliderValue = 10}
      if(this.currentPassengerStep === 2) {this.passengerSliderValue = 20}
      if(this.currentPassengerStep === 3) {this.passengerSliderValue = 39}
      if(this.currentPassengerStep === 4) {this.passengerSliderValue = 50}
      if(this.currentPassengerStep === 5) {this.passengerSliderValue = 61}
      if(this.currentPassengerStep === 6) {this.passengerSliderValue = 76}
      if(this.currentPassengerStep === 7) {this.passengerSliderValue = 100}
    },
    increaseDriver() {
      if(this.currentDriverStep === this.maxDriverSteps) { return; } else {
        this.currentDriverStep += 1;
        this.checkDriverLocation();
      }
    },
    decreaseDriver() {
      if(this.currentDriverStep === 1) { return; } else {
        this.currentDriverStep -= 1;
        this.checkDriverLocation();
      }
    },
    checkDriverLocation() {
      if(this.currentDriverStep === 1) {this.driverSliderValue = 10}
      if(this.currentDriverStep === 2) {this.driverSliderValue = 20}
      if(this.currentDriverStep === 3) {this.driverSliderValue = 39}
      if(this.currentDriverStep === 4) {this.driverSliderValue = 50}
      if(this.currentDriverStep === 5) {this.driverSliderValue = 61}
      if(this.currentDriverStep === 6) {this.driverSliderValue = 76}
      if(this.currentDriverStep === 7) {this.driverSliderValue = 100}
    }
  }
}
</script>

<style lang="scss">

.blackUnderline {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-bottom: 8px solid black;
  width: 230px;
}

.laneToggle {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 30px;
  p {margin-bottom: 0;}
}

.header {
  margin-top: 50px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.camber-header {
    flex-direction: column;

    @media(min-width: 768px) {
    flex-direction: row;
  }
  }

  @media(min-width: 992px) {
    margin-bottom: 4rem;
  }

  .treadWear {
    padding-top: 1rem;

    h6 {
      margin-bottom: 10px;
    }
  }

  .introText {
    max-width: 450px;
  }
}
.disclaimer {
  text-align: center;
}
.interactive {
  display: flex;
  margin-bottom: 50px;

  flex-direction: column;
  align-items: center;
  padding: 4rem 0;
  justify-content: center;

  @media(min-width: 1079px) {
    flex-direction: row;
    padding: 4rem;
    padding-top: 0;
    padding-bottom: 0;
  }
}

.driverCamber, .passengerCamber {

  h6 {
    margin: 0 auto;
    text-align: center;

    @media(min-width: 992px) {
      width: 70%;
    }
  }

    @media(min-width: 992px) {
    max-width: 230px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}

.carDiagram {

  max-width: 600px;

}

.diagram {
  position: relative;
}
.car {position: relative; z-index: 5;}
.tire {
  position: absolute; bottom: 15%; z-index: 1;
  width: 12%;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.leftTire {left: 6%; height: 40%; z-index: 2;}
.rightTire {right: 6%; height: 40%; z-index: 2;}
.axel {
  position: relative;
  width: 100%; display: flex; margin: 0 auto; transform: translateY(-80%);
  justify-content: center;
  z-index: 1;
  img {width: 70%;}
}
.passengerSlider { width: 65%; margin: 0 auto; display: block; margin-bottom: 50px;}
.passengerScale { padding: 10px; width: 100%; }
</style>
